import { render, staticRenderFns } from "./draw-on-video.vue?vue&type=template&id=5e12b4aa&scoped=true"
import script from "./draw-on-video.vue?vue&type=script&lang=js"
export * from "./draw-on-video.vue?vue&type=script&lang=js"
import style0 from "./draw-on-video.vue?vue&type=style&index=0&id=5e12b4aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e12b4aa",
  null
  
)

export default component.exports